export const users = [
  {
    id: 5,
    username: "yanbaba",
    fullname: "Chijioke Igwendu",
    admin: true,
    role: "boss",
    pic: "user-4.png",
  },
  {
    id: 2,
    username: "dave",
    fullname: "David Ojonugba",
    admin: true,
    role: "chief-editor",
    pic: "user-2.png",
  },
  {
    id: 3,
    username: "stanely",
    fullname: "Stanely Uka",
    admin: false,
    role: "editor",
    pic: "user-3.png",
  },
  {
    id: 4,
    username: "kelechi",
    fullname: "Nimem Kelechi",
    admin: false,
    role: "editor",
    pic: "user-4.png",
  },
  {
    id: 5,
    username: "asher",
    fullname: "Arinze Michael",
    admin: false,
    role: "editor",
    pic: "user-5.png",
  },
  {
    id: 5,
    username: "vivian",
    fullname: "Vivian Mbise",
    admin: false,
    role: "editor",
    pic: "user-9.png",
  },
  {
    id: 5,
    username: "chioma",
    fullname: "Chioma Chukwuka",
    admin: false,
    role: "editor",
    pic: "user-8.png",
  },
  {
    id: 5,
    username: "gospel",
    fullname: "Gospel John",
    admin: true,
    role: "manager",
    pic: "user-7.png",
  },
  {
    id: 1,
    username: "lawrencejr",
    fullname: "Oputa Ifeanyi Lawrence",
    pic: "user-6.png",
    admin: true,
    role: "developer",
  },
  {
    id: 1,
    username: "effa",
    fullname: "Effa Desmond",
    pic: "user-6.png",
    admin: false,
    role: "editor",
  },
];
